<template>
  <div class="kachel" :class="additionalClasses">
    <div class="kachel_header">
      {{ myProdukt.stammdaten.name }}
    </div>
    <div class="kachel_body">
      {{ myProdukt.stammdaten.kurztext }}
      <p />
      Preis: {{myProdukt.stammdaten.preis}} €
    </div>
    <div class="kachel_bild" v-if="myImage">
      <img style="width:100%" :src="myImage" />
    </div>
    <div class="kachel_footer">
       <q-btn color="primary"  @click="router.push('/produkt/'+myProdukt._id)" label="Zur Produktseite" />
    </div>
  </div>
</template>

<script>
import { ref ,computed} from "vue";
import { useRouter } from "vue-router";

export default {
  props: {
    produkt: Object,
    teaser: { type: Boolean, default: false },
  },
  emits: ["refreshWarenkorb"], // <--- add this line
  components: {},
  setup(props) {
    const router = useRouter();
    let myProdukt = ref(props.produkt);
    let additionalClasses = myProdukt.value.stammdaten.teaser === true ? "teaser" : "";

    function clicked() {
      router.push("/produkt/" + myProdukt.value._id);
    }

  let myImage = computed(() => {

      const BASE='https://vkf.format-c.info/produktimages/';
      if(myProdukt.value.fotos.length==0){
        return ""
      }
      for (let i = 0; i < myProdukt.value.fotos.length; i++) {
        const foto = myProdukt.value.fotos[i];
        if(foto.default_home===true){
          console.log('BASE+myProdukt.value._id+foto.name',foto.name)
          return BASE+myProdukt.value._id+'/small_'+foto.name
        }
      }
      return BASE+myProdukt.value._id+'/small_'+myProdukt.value.fotos[0].name
      
    })
    
    return {
      myProdukt,
      router,
      clicked,
      additionalClasses,
      myImage
    };
  },
};
</script>

<style scoped lang="scss">
.kachel {
  border: 1px solid #cecece;
  position:relative;
  border-radius: 5px;
  overflow:hidden;
  width: 100%;
  -webkit-box-shadow: 0px 0px 17px 2px rgba(0, 0, 0, 0.4); /** https://html-css-js.com/css/generator/box-shadow/ */
  box-shadow: 0px 0px 17px 2px rgba(0, 0, 0, 0.4);
}

.kachel_header {
  border-radius: 5px 5px 0px 0px;
  padding: 5px;
  height: 30px;
  background-color: #e20074;
  color: #fff;
}

.kachel_footer {
  position:absolute;
  text-align:right;
  bottom:0px;
  border-radius: 5px 5px 0px 0px;
  padding: 5px;
  width:100%;
  height: 50px;
  color: #fff;
}

.kachel_bild{
  position:absolute;
  right:0px;
  top:30px;
  width:50%
}




.kachel_body {
  padding: 5px;
  height: 250px;
  background-color: FFF;
  color: #000;
  border-radius: 0px 0px 5px 5px;
}
</style>
